import styled from "styled-components";

export const InputFilesWrapper = styled.div`
  form {
    margin-top: 38px;
  }
  .ant-form-item-label label {
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    color: var(--text-color, #1c1c1c);
  }
  .ant-select-selector {
    border-radius: 8px;
    border: 1px solid var(--border-color-secondary, #eaeaea) !important;
    background: var(--bg-color-secondary, #fafafa) !important;
    height: 56px !important;
  }
  .ant-select-arrow {
    height: 100%
  }

  .ant-select-selector .ant-select-selection-item,
  .ant-select-selector .ant-select-selection-placeholder {
    line-height: 53px !important;
    font-family: "PoppinsRegular", sans-serif !important;
  }
  .ant-select-item {
    padding: 16px !important;
  }

  *:disabled {
    color: var(--text-color, black);
  }

  /* Match the Run page's InputFiles label-row layout so the disabled job-config
     view gets the same clean download icon button on each input. */
  .ant-form-item-label > label {
    width: 100%;
  }
  .ant-form-item-label > label::after {
    content: none !important;
  }
  .input-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
  }
  .input-label-actions {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
  }
  .label-icon-btn {
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--text-color-muted, rgba(0, 0, 0, 0.45));
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
    transition: color 0.15s ease, background-color 0.15s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .label-icon-btn:hover {
    color: var(--primary-color, #0c77dc);
    background-color: var(--hover-bg, rgba(12, 119, 220, 0.08));
  }
  .label-icon-btn:disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    background-color: transparent;
  }
`;
